export enum MISC_PATHS {
  MISC_CLASS = "/miscellaneous-insurance",
  PORTABLE_ELECTRONIC_EQUIPMENT_INSURANCE = "/miscellaneous-insurance/portable-electronic-equipment-insurance-policy",
  MONEY_INSURANCE_POLICIES = "/miscellaneous-insurance/money-insurance-policies",
  EMPLOYEE_CRIME_FIDELITY_GUARANTEE_INSURANCE = "/miscellaneous-insurance/employee-crime-fidelity-guarantee-insurance",
  PLATE_GLASS_INSURANCE_POLICY = "/miscellaneous-insurance/plate-glass-insurance-policy",
}
